import React from 'react'
import Layout from "../components/layout"
import { Parallax } from 'react-parallax'
import { Grid, Row, Col} from 'react-bootstrap'
import SEO from "../components/seo"
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { graphql } from 'gatsby'


const CareersPage = ({ data }) =>
    <Layout>
    <SEO title="Careers | Korecki Real Estate Services" description="Our Strata Property Management and Residential Property Management portfolio is rapidly growing, and we are always on the lookout for well qualified, ambitious team players" keywords="korecki,Real Estate,Strata Management services, Job, Career, Careers, Korecki Team"/>
      <div>
          <Parallax bgImage={require('../images/seawall_v2.jpg')} bgImageAlt="Strata" strength={200}>
              <Grid>
                  <Row>
                      <Col md={12}>
                          <h1>Careers</h1>
                      </Col>
                  </Row>
              </Grid>
          </Parallax>
          <div className="divCareers">
              <h3 align="center">{data.contentfulCareersPage.title}</h3>
              <div className="custom-text-color-children">
                  {documentToReactComponents(data.contentfulCareersPage.bodyText.json)}
              </div>
          </div>
      </div>
  </Layout>

export const query = graphql`
  {
      contentfulCareersPage(title: {eq: "Join the Korecki Team"}) {
      title
      bodyText {
        json
      }
    }
  }`

export default CareersPage
